/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

const getDisabledButton = ({ disabled, theme }) => disabled && `
  background-color: ${theme.black10};
  color: ${theme.black20};
  cursor: auto;
  border: 1px solid ${theme.black10};
  box-shadow: none;
`;

export const Card = styled.div`
  display: flex;
  padding: 16px;
  overflow: auto;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  border-radius: 4px;
  background-color: ${({ theme }) => theme.white};
  flex-direction: column;
`;

export const Button = styled.button`
    align-items: center;
    justify-content: center;
    min-width: 64px;
    border: 1px solid ${({ theme }) => theme.primary};
    border-radius: 4px;
    text-transform: uppercase;
    padding: 6px 16px;
    line-height: 1.75;
    cursor: pointer;
    font-weight: bold;
    letter-spacing: 0.02857em;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
    background-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.white};
    ${getDisabledButton}
`;

export const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: ${({ marginTop }) => (marginTop || 0)}px;
  padding-top: ${({ paddingTop }) => (paddingTop || 0)}px;
`;

export const ButtonContainer = styled(Box)`
  margin-top: 10px;
`;
